
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"clip-path"}},[_c('rect',{attrs:{"id":"Rectangle_15903","data-name":"Rectangle 15903","width":"18","height":"18","transform":"translate(1 1)","fill":"none"}})])]),_c('g',{attrs:{"id":"Group_47575","data-name":"Group 47575","transform":"translate(-3.703 -3.703)"}},[_c('g',{attrs:{"id":"Group_47571","data-name":"Group 47571","transform":"translate(2.703 2.703)","clip-path":"url(#clip-path)"}},[_c('path',{attrs:{"id":"Path_33813","data-name":"Path 33813","d":"M20.1 23.457l3.307-3.3.035-.035m0 0L20.1 16.778m3.341 3.342h-8.349","transform":"translate(-3.053 -2.992)","fill":"#dfe4ef"}}),_c('path',{attrs:{"id":"Path_33824","data-name":"Path 33824","d":"M17.687 5.861v8.278a1.774 1.774 0 01-1.774 1.774H4.088a1.774 1.774 0 01-1.774-1.775V5.861m15.373 0a1.774 1.774 0 00-1.774-1.774H4.088a1.774 1.774 0 00-1.774 1.774m15.373 0v.192a1.774 1.774 0 01-.844 1.511l-5.912 3.638a1.774 1.774 0 01-1.861 0L3.158 7.564a1.774 1.774 0 01-.844-1.51v-.193","fill":"none","stroke":"#6b7787","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])])])
          )
        }
      }
    